export const LOAD_PLAYLIST_START = 'playlists/LOAD_PLAYLIST_START';
export const LOAD_PLAYLIST_COMPLETE = 'playlists/LOAD_PLAYLIST_COMPLETE';
export const FILTER_PLAYLIST_ITEMS = 'playlists/FILTER_PLAYLIST_ITEMS';
export const FILTER_PLAYLIST_ITEMS_START = 'playlists/FILTER_PLAYLIST_ITEMS_START';
export const FILTER_PLAYLIST_ITEMS_COMPLETE = 'playlists/FILTER_PLAYLIST_ITEMS_COMPLETE';
export const PLAYLIST_CYCLED = 'playlists/PLAYLIST_CYCLED';

export const SELECT_PLAYLIST = 'playlists/SELECT_PLAYLIST';

export const ACTIVATE_PLAYLIST_START = 'playlists/ACTIVATE_PLAYLIST_START';
export const ACTIVATE_PLAYLIST_COMPLETE = 'playlists/ACTIVATE_PLAYLIST_COMPLETE';

export const LOAD_ALL_PLAYLISTS_START = 'playlists/LOAD_ALL_PLAYLISTS_START';
export const LOAD_ALL_PLAYLISTS_COMPLETE = 'playlists/LOAD_ALL_PLAYLISTS_COMPLETE';

export const CREATE_PLAYLIST_START = 'playlists/CREATE_PLAYLIST_START';
export const CREATE_PLAYLIST_COMPLETE = 'playlists/CREATE_PLAYLIST_COMPLETE';

export const RENAME_PLAYLIST_START = 'playlists/RENAME_PLAYLIST_START';
export const RENAME_PLAYLIST_COMPLETE = 'playlists/RENAME_PLAYLIST_COMPLETE';

export const DELETE_PLAYLIST_START = 'playlists/DELETE_PLAYLIST_START';
export const DELETE_PLAYLIST_COMPLETE = 'playlists/DELETE_PLAYLIST_COMPLETE';

export const OPEN_ADD_MEDIA_MENU = 'playlists/OPEN_ADD_MEDIA_MENU';
export const CLOSE_ADD_MEDIA_MENU = 'playlists/CLOSE_ADD_MEDIA_MENU';
export const ADD_MEDIA_START = 'playlists/ADD_MEDIA_START';
export const ADD_MEDIA_COMPLETE = 'playlists/ADD_MEDIA_COMPLETE';

export const REMOVE_MEDIA_START = 'playlists/REMOVE_MEDIA_START';
export const REMOVE_MEDIA_COMPLETE = 'playlists/REMOVE_MEDIA_COMPLETE';

export const MOVE_MEDIA_START = 'playlists/MOVE_MEDIA_START';
export const MOVE_MEDIA_COMPLETE = 'playlists/MOVE_MEDIA_COMPLETE';

export const UPDATE_MEDIA_START = 'playlists/UPDATE_MEDIA_START';
export const UPDATE_MEDIA_COMPLETE = 'playlists/UPDATE_MEDIA_COMPLETE';

export const SHUFFLE_PLAYLIST_START = 'playlists/SHUFFLE_PLAYLIST_START';
export const SHUFFLE_PLAYLIST_COMPLETE = 'playlists/SHUFFLE_PLAYLIST_COMPLETE';
